<div class="toast-booking">
    <p-toast position="top-right" [key]="keyToast" class="w-[29rem] max-w-full sm:w-[90%] sm:right-[5%]">
        <ng-template let-message pTemplate="message">
            <i [ngClass]="toastIconMap[message.severity]" class="!text-xl !leading-[20px]"></i>
            <div class="toast-content">{{ message.detail }}</div>
        </ng-template>
    </p-toast>
</div>

